export default __webpack_public_path__ + "static/0-fd1d056d18d5d06e972fa8f518dbd4fb.jpg";